import fr from "./translations/fr";
import en from "./translations/en";
export default {
  fr,
  en,
};
